import styled from 'styled-components'

/*
  TODO:

  Refactor/rename things so that we have two separate concepts:

  1) The actual workspace view/state where input parameters are assigned
  2) A common layout for views

  Currently we use workspace for both (i.e. results window uses
  workspace styles but the input assignment view/app state is called
  workspace).

*/

export const AnimWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: 100%;

  &.resultanim-appear {
    opacity: 0;
    top: 50%;
    position: absolute;
    z-index: 600;
  }

  &.resultanim-appear-active {
    /* bottom: -2000px; */
    opacity: 1;
    top: 100px;
    /* position: absolute; */
  }

  transition: opacity 0.5s, top 0.5s;
  position: relative;
`

export const WorkspaceWindow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
`

export const MainView = styled.div`
  flex: 1 1 auto;
  min-width: 300px;
  background: white;
  margin: 0 0px;
  display: flex;
  flex-direction: column;
`

export const Panel = styled.div`
  border: 1px solid #cecece;
`

export const WorkspaceToolbar = styled.div`
  min-height: 30px;

  background: ${({ theme }) => theme.toolbar.background};
  font-size: ${({ theme }) => theme.toolbar.fontSize};

  margin: 0;
  padding: 7px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  a {
    color: ${({ theme }) => theme.toolbar.color};
  }

  h2 {
    color: ${({ theme }) => theme.toolbar.color};
    font-size: 20px;
  }

  .right {
    margin-left: auto;
  }

  .toolbar-header {
    font-weight: bold;
    padding-right: 2em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.toolbar.color};
  }

  .center {
    position: relative;
    right: 50%;
    top: 0;
    color: ${({ theme }) => theme.toolbar.color};
  }
`

export const WorkspaceStatusBar = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
`

export const ToolbarButton = styled.button`
  border: 0;
  background: transparent;
  font-size: ${({ theme }) => theme.toolbar.buttonFontSize};
  font-weight: bold;
  margin-right: 10px;
  outline: 0;
  color: ${({ theme }) => theme.toolbar.color};
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/Components/Workspace/WorkspaceStyles.tsx